import type { FunctionComponent } from 'react';

import { useGameConfig } from '../../../../config/GameConfigProvider';
import { NavPage } from '../page/NavPage';

export const NavPageBetLimitsConnected: FunctionComponent = () => {
  const { betLimitContent } = useGameConfig();

  return <NavPage>{betLimitContent}</NavPage>;
};
